import OnFire from 'onfire.js';
// 创建 onFire 事件实例
const onFire = new OnFire();

export default onFire;